import axios from "axios";

import { IP } from "../utils/Host";


export function updateZmienCzasTrwaniaGrupyGant(drop_grupa_global_id,nowy_koniec,refreshGantAll) {



  axios.get(IP + "zmienCzasTrwaniaGrupy/"+drop_grupa_global_id+"/"+nowy_koniec)
    .then((res) => {

      console.log("grupa_global_id: "+drop_grupa_global_id)
      console.log("nowy_koniec: "+nowy_koniec)

    refreshGantAll()

    });
}
